import React, { useEffect, useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { ORDERS_COLLECTION, serverTimestamp } from '../../firebase'
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";

const INITIAL_STATE = {
    contact: '',
    date: serverTimestamp.now(),
    done: false,
    game: '',
    method_of_payment: '',
    name: '',
    price: ''
}

const EditOrder = () => {

    const { id } = useParams()

    const history = useHistory()

    const [edit, setEdit] = useState(INITIAL_STATE)

    const handleEdit = async (e) => {

        e.preventDefault();

        await ORDERS_COLLECTION.doc(id).set({
            _id: id,
            contact: edit.contact,
            date: edit.date,
            done: 'true' === edit.done,
            game: edit.game,
            method_of_payment: edit.method_of_payment,
            name: edit.name,
            price: edit.price
        })
            .then(() => {
                alert("Uspješno uređeno 👍")
                history.push('/preview-order')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await ORDERS_COLLECTION.where('_id', '==', id).get()
            snapshot.forEach(doc => {
                setEdit(doc.data())
            })
        }

        getItems();

    }, []);

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="edit-order" className="mb-3" transition={false}>
                    <Tab eventKey="preview-order" title={<div onClick={() => history.push('/preview-order')}>Pregled igara</div>} />
                    <Tab eventKey="add-order" title={<div onClick={() => history.push('/add-order')}>Dodaj</div>} />
                    <Tab eventKey="edit-order" title="Uredi">
                        <Form onSubmit={handleEdit}>
                            <Row>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Kontakt</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Kontakt"
                                            value={edit.contact}
                                            onChange={(e) => { setEdit({ ...edit, contact: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Završeno</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={edit.done}
                                            onChange={(e) => { setEdit({ ...edit, done: e.target.value }) }}
                                            required
                                        >
                                            <option value="" disabled>Odaberite</option>
                                            <option value="false">Ne</option>
                                            <option value="true">Da</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Igra</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Igra"
                                            value={edit.game}
                                            onChange={(e) => { setEdit({ ...edit, game: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Način plaćanja</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={edit.method_of_payment}
                                            onChange={(e) => { setEdit({ ...edit, method_of_payment: e.target.value }) }}
                                            required
                                        >
                                            <option value="" disabled>Odaberite</option>
                                            <option value="Uplatnica (banka ili pošta)">Uplatnica (banka ili pošta)</option>
                                            <option value="Paypal (+5% provizija)">Paypal (+5% provizija)</option>
                                            <option value="Xbon (+5% provizija)">Xbon (+5% provizija)</option>
                                            <option value="Kriptovalute (stablecoins)">Kriptovalute (stablecoins)</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ime</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Ime"
                                            value={edit.name}
                                            onChange={(e) => { setEdit({ ...edit, name: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cijena</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Cijena"
                                            value={edit.price}
                                            onChange={(e) => { setEdit({ ...edit, price: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Button variant="primary" type="submit">
                                        Uredi
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="delete-order" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default EditOrder
